/**
 * Scratch-VM Compatible IR Sensor Extension
 *
 * This file is the GUI-side version of the IR sensor extension,
 * written in ES module format so it can be imported by the GUI's
 * extension-library.jsx. It uses the same API surface as a
 * scratch-vm built-in extension.
 *
 * Block opcodes here match what the CodeTemplateRegistry uses
 * for code generation.
 */
import formatMessage from 'format-message';

const DIGITAL_PIN_MENU = ['2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13'];
const ANALOG_PIN_MENU = ['A0', 'A1', 'A2', 'A3', 'A4', 'A5'];

class Scratch3IRSensorBlocks {
    constructor (runtime) {
        this.runtime = runtime;
    }

    getInfo () {
        return {
            id: 'irSensor',
            name: formatMessage({
                id: 'gui.extension.irSensor.name',
                default: 'IR Sensor'
            }),
            color1: '#FF6F00',
            color2: '#E65100',
            color3: '#BF360C',
            blocks: [
                {
                    opcode: 'irReadDigital',
                    blockType: 'Boolean',
                    text: formatMessage({
                        id: 'irSensor.blocks.detectsObject',
                        default: 'IR sensor on pin [PIN] detects object?'
                    }),
                    arguments: {
                        PIN: {
                            type: 'string',
                            menu: 'digitalPinMenu',
                            defaultValue: '2'
                        }
                    }
                },
                {
                    opcode: 'irReadAnalog',
                    blockType: 'reporter',
                    text: formatMessage({
                        id: 'irSensor.blocks.value',
                        default: 'IR sensor value on pin [PIN]'
                    }),
                    arguments: {
                        PIN: {
                            type: 'string',
                            menu: 'analogPinMenu',
                            defaultValue: 'A0'
                        }
                    }
                },
                '---',
                {
                    opcode: 'irWaitDetect',
                    blockType: 'command',
                    text: formatMessage({
                        id: 'irSensor.blocks.waitUntil',
                        default: 'wait until IR sensor on pin [PIN] detects object'
                    }),
                    arguments: {
                        PIN: {
                            type: 'string',
                            menu: 'digitalPinMenu',
                            defaultValue: '2'
                        }
                    }
                }
            ],
            menus: {
                digitalPinMenu: {
                    acceptReporters: true,
                    items: DIGITAL_PIN_MENU
                },
                analogPinMenu: {
                    acceptReporters: true,
                    items: ANALOG_PIN_MENU
                }
            }
        };
    }

    // VM-side simulation handlers (real interaction happens via generated code)

    irReadDigital () {
        return Math.random() > 0.5;
    }

    irReadAnalog () {
        return Math.floor(Math.random() * 1024);
    }

    irWaitDetect () {
        return new Promise(resolve => {
            setTimeout(resolve, 500);
        });
    }
}

export default Scratch3IRSensorBlocks;
